import { render } from "./Guide.vue?vue&type=template&id=53f4d6a1&ts=true"
import script from "./Guide.vue?vue&type=script&lang=ts"
export * from "./Guide.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__